import { LocalStorageService } from 'ngx-webstorage';

export class Store {
  constructor(public localStorage: LocalStorageService) {}
}
